import { useState } from 'react'

import { t, term } from '../i18n'
import { longDate } from '../lib/format'
import { useBackButton } from '../lib/navigation'
import { haptic } from '../lib/telegram'
import type { Photo } from '../lib/types'
import { Button } from './Card'
import { Icon } from './Icon'
import { usePhotoUrl } from './PhotoImage'

export function PhotoViewer({
  photo,
  comparable,
  deleting,
  onCompare,
  onDelete,
  onClose,
}: {
  photo: Photo
  comparable: boolean
  deleting: boolean
  onCompare: () => void
  onDelete: () => void
  onClose: () => void
}) {
  const url = usePhotoUrl(photo.id)
  const [confirming, setConfirming] = useState(false)

  useBackButton(onClose)

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-viewfinder">
      <div className="relative min-h-0 flex-1">
        {url ? <img src={url} alt="" className="h-full w-full object-contain" /> : null}

        <div className="absolute inset-x-4 top-[calc(var(--spacing-safe-top)+16px)] flex items-center gap-2">
          <button
            type="button"
            onClick={onClose}
            aria-label={t.photos.closeViewer}
            className="pressable flex h-tap w-tap items-center justify-center rounded-capsule border border-nav bg-nav text-text backdrop-blur-3"
          >
            <Icon name="x" size={18} />
          </button>
          <span className="flex h-tap items-center rounded-capsule border border-nav bg-nav px-[14px] text-hint text-text backdrop-blur-3">
            {term('angle', photo.angle)}
          </span>
          <span className="flex h-tap items-center rounded-capsule border border-nav bg-nav px-[14px] text-hint text-text backdrop-blur-3">
            {longDate(photo.takenAt.slice(0, 10))}
          </span>
        </div>
      </div>

      <div className="flex flex-none gap-2 rounded-t-sheet-matte border-t border-hairline-soft bg-sheet-matte px-[14px] pb-[calc(14px+var(--spacing-safe-bottom))] pt-[14px]">
        {comparable ? (
          <div className="flex-1">
            <Button
              tone="secondary"
              onClick={() => {
                setConfirming(false)
                onCompare()
              }}
            >
              <Icon name="columns" size={17} />
              {t.photos.compareAction}
            </Button>
          </div>
        ) : null}
        <div className="flex-1">
          <Button
            tone="danger"
            onClick={() => {
              if (!confirming) {
                haptic.select()
                setConfirming(true)
                return
              }
              onDelete()
            }}
            disabled={deleting}
          >
            <Icon name="trash" size={17} />
            {confirming ? t.photos.deleteConfirm : t.photos.delete}
          </Button>
        </div>
      </div>
    </div>
  )
}
